
export default class ErrorManager{
    constructor(){
        this.errorMessages = [];

        this.getErrors = this.getErrors.bind(this);
        this.addError = this.addError.bind(this);
        this.addErrors = this.addErrors.bind(this);
        this.addCodedError = this.addCodedError.bind(this);
        this.addCodedErrors = this.addCodedErrors.bind(this);
        this.reset = this.reset.bind(this);
        this.getErrorCount = this.getErrorCount.bind(this);
    }
    

    reset(){
        this.errorMessages = [];
    }

    getErrors(){
        return this.errorMessages;
    }

    addCodedError ( code, description ){
        this.errorMessages.push( {index: this.errorMessages.length, code, description} );
    }

    addCodedErrors( errors ){
        errors.map( e => this.addCodedError(e.code, e.description ));
    }

    addError( description ){
        this.addCodedError( '', description);
    }

    addErrors( errors ){
        this.addCodedErrors( errors.map( e => this.addError(e)));
    }

    getErrorCount(){
        return this.errorMessages.length;
    }

}